export default __webpack_public_path__ + "static/media/transcoding.508f62af.gif";